import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { FileText, ArrowRight } from "lucide-react";
import { format } from "date-fns";

export default function HouseViewWidget() {
  const { data: items } = useQuery({
    queryKey: ["house_view_widget"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("research_items")
        .select("id, title, ai_summary, summary, published_at, primary_axis, portfolio_level, conviction")
        .eq("status", "published")
        .order("published_at", { ascending: false })
        .limit(5);
      if (error) throw error;
      return data ?? [];
    },
  });

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="flex items-center gap-2 text-primary">
          <FileText className="h-5 w-5" /> Latest House Views
        </CardTitle>
        <Button asChild variant="ghost" size="sm">
          <Link to="/partner/house-view">View all <ArrowRight className="h-4 w-4 ml-1" /></Link>
        </Button>
      </CardHeader>
      <CardContent className="space-y-3">
        {(!items || items.length === 0) && (
          <p className="text-sm text-muted-foreground">No entries</p>
        )}
        {items?.map((it: any) => (
          <Link
            key={it.id}
            to={`/partner/house-view/${it.id}`}
            className="block p-3 rounded-lg border hover:border-primary transition-colors"
          >
            <div className="flex items-start justify-between gap-2">
              <p className="font-medium text-sm">{it.title}</p>
              {it.conviction && <Badge variant="outline" className="text-xs">{it.conviction}/5</Badge>}
            </div>
            {(it.ai_summary || it.summary) && (
              <p className="text-xs text-muted-foreground mt-1 line-clamp-2">
                {it.ai_summary || it.summary}
              </p>
            )}
            <div className="flex flex-wrap gap-1 mt-1 text-xs text-muted-foreground">
              {it.published_at && <span>{format(new Date(it.published_at), "dd/MM/yyyy")}</span>}
              {it.primary_axis && <span>· {it.primary_axis}</span>}
              {it.portfolio_level && <span>· P{it.portfolio_level}</span>}
            </div>
          </Link>
        ))}
      </CardContent>
    </Card>
  );
}
